import {Component, OnInit} from '@angular/core';
import {TabViewModule} from 'primeng/tabview';
import {TranslateModule} from '@ngx-translate/core';
import {NavService} from '../../_services/_nav.service';
import {TableModule} from 'primeng/table';
import {NgForOf, NgIf} from '@angular/common';
import {ListaItem} from '../../_models/lista-item';
import {ListaService} from '../../_services/lista.service';
import {TiposOcupacionesCapacidadPagos} from '../../_models/tipos-ocupaciones-configuraciones-capacidad-pagos';
import {firstValueFrom, forkJoin} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {
  TiposOcupacionesConfiguracionesCapacidadPagosService
} from '../../_services/tipos-ocupaciones-configuraciones-capacidad-pagos.service';
import {CheckboxModule} from 'primeng/checkbox';
import {FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {TipoOcupacionConfiguracionService} from '../../_services/tipo-ocupacion-configuracion.service';
import {TipoOcupacionConfiguracion} from '../../_models/tipo-ocupacion-configuracion';
import {DisableTabDirective} from '../../_helpers/disable-tab.directive';
import {DropdownModule} from 'primeng/dropdown';
import {SelectItem} from 'primeng/api';
import {DisableCDirective} from '../../_helpers/disable-c.directive';
import {InputTextModule} from 'primeng/inputtext';
import {SharedModule} from '../../shared/shared.module';
import {ButtonModule} from 'primeng/button';
import {TiposOcupacionesConfiguracionesDescuentosSalarios} from '../../_models/tiposOcupacionesConfiguracionesDescuentosSalarios';
import {RippleModule} from 'primeng/ripple';
import {AutenticacionService} from '../../_services/autenticacion.service';

@Component({
  selector: 'app-capacidad-pago-ocupacion',
  standalone: true,
  imports: [
    TabViewModule,
    TranslateModule,
    TableModule,
    NgForOf,
    NgIf,
    CheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    DisableTabDirective,
    DropdownModule,
    DisableCDirective,
    InputTextModule,
    SharedModule,
    ButtonModule,
    RippleModule
  ],
  templateUrl: './capacidad-pago-ocupacion.component.html',
  styleUrl: './capacidad-pago-ocupacion.component.css'
})
export class CapacidadPagoOcupacionComponent implements OnInit {
  summit: boolean = false;
  cargando :boolean = true;
  idTipoOcupacionConfiguracion: string;
  tipOcupacion:TipoOcupacionConfiguracion;
  carTabla: boolean;
  carTablaDescuentos: boolean;
  listafuentescapacidadPago : ListaItem[] = [];
  selectListaFuentescapacidadPago : SelectItem[] = [];
  listasDecisionesCapacidadPagoOcupaciones : ListaItem[] = [];
  columnas: any[];
  columnasDescuentoSalarioXley: any[];
  ocupacionConfiguracionCapacidadPago : TiposOcupacionesCapacidadPagos[];
  configuracionesDescuentosSalarios : TiposOcupacionesConfiguracionesDescuentosSalarios[];
  formulario: FormGroup;
  formDesSalarios : FormGroup;
  indicadorFijarUno = false;
  mayorDesde : number;
  editando : TiposOcupacionesConfiguracionesDescuentosSalarios;

  constructor(
    private route: ActivatedRoute,
    private navServicio: NavService,
    private lisServicio: ListaService,
    private tipOcupacionConfiguracionServicio: TipoOcupacionConfiguracionService,
    private ocupacionesConfiguracionesCapacidadPagosService: TiposOcupacionesConfiguracionesCapacidadPagosService,
    private autServicio: AutenticacionService,
    private fb: FormBuilder,
  ) {
  }


  ngOnInit() {
    this.carTabla = true;
    this.cargando = true
    this.idTipoOcupacionConfiguracion = this.route.snapshot.params['id'];
    this.columnas = [
      { field: 'fuente', header: this.navServicio.buscarMensaje( 'CAPACIDADPAGOOCUPACION.LBL_FUENTE' ), sort: false },
      { field: 'perfil', header: this.navServicio.buscarMensaje( 'CAPACIDADPAGOOCUPACION.LBL_PERFIL' ), sort: false },
      { field: 'estimador', header: this.navServicio.buscarMensaje( 'CAPACIDADPAGOOCUPACION.LBL_ESTIMADOR' ), sort: false },
      { field: 'aplicargastos', header: this.navServicio.buscarMensaje( 'CAPACIDADPAGOOCUPACION.LBL_APLICARGASTOS' ), sort: false },
      { field: 'indicadorAch', header: this.navServicio.buscarMensaje( 'CAPACIDADPAGOOCUPACION.LBL_TRANSFERENCIAACH' ), sort: false },
      { field: 'lanzarnoaplicar', header: this.navServicio.buscarMensaje( 'CAPACIDADPAGOOCUPACION.LBL_LANZARNOAPLICAR' ), sort: false },
      { field: 'habilitado', header: this.navServicio.buscarMensaje( 'CAPACIDADPAGOOCUPACION.LBL_HABILITADO' ), sort: false },
    ];
    this.columnasDescuentoSalarioXley = [
      { field: 'desde', header: this.navServicio.buscarMensaje( 'CAPACIDADPAGOOCUPACION.LBL_DESDESMLV' ), sort: false },
      { field: 'hasta', header: this.navServicio.buscarMensaje( 'CAPACIDADPAGOOCUPACION.LBL_HASTASMLV' ), sort: false },
      { field: 'descuentos', header: this.navServicio.buscarMensaje( 'CAPACIDADPAGOOCUPACION.LBL_DESCUENTOS' ), sort: false },
      { field: 'impuestos', header: this.navServicio.buscarMensaje( 'CAPACIDADPAGOOCUPACION.LBL_IMPUESTOS' ), sort: false },
      { field: 'acciones', header: this.navServicio.buscarMensaje( 'CAPACIDADPAGOOCUPACION.LBL_ACCIONES' ), sort: false },
    ];
    this.tipOcupacionConfiguracionServicio.obtenerPorId( this.idTipoOcupacionConfiguracion ).subscribe( tipOcupacion => {
      this.tipOcupacion = tipOcupacion;
    } );
    this.cargarListas();
    this.cargarListasDescuentosSalarios();
    this.cargarformDesSalarios();
  }
  cargarFormulario() {
    this.formulario = this.fb.group({
      decisionCapacidadPago: this.fb.array(
        this.listasDecisionesCapacidadPagoOcupaciones.map(item =>
          this.fb.control(item.idLista === this.tipOcupacion?.idDecisionCapacidadPago)
        )
      ),
      idFuenteCapacidadPago:[this.tipOcupacion?.idFuenteCapacidadPago ? this.tipOcupacion?.idFuenteCapacidadPago : null],
    });
    this.indicadorFijarUno = this.tipOcupacion?.idFuenteCapacidadPago ? true : false;
  }
  cargarformDesSalarios(){
    this.formDesSalarios = this.fb.group({
      desde:[null,[ Validators.required ]],
      hasta:[null,[ Validators.required ]],
      porcentajeDescuentoLey:[null,[ Validators.required ]],
      porcentajeImpuesto:[null,[ Validators.required ]],
    })
  }

  get f() {
    return this.formulario.controls;
  }
  get fd() {
    return this.formDesSalarios.controls;
  }

  cargarListas(){
    forkJoin([
        this.lisServicio.getMasterDetails( 'ListasFuentesCapacidadPago' ),
        this.lisServicio.getMasterDetails( 'ListasDecisionesCapacidadPagoOcupaciones' ),
        this.ocupacionesConfiguracionesCapacidadPagosService.obternerOcupacionCofiguracionCapacidadPago(this.idTipoOcupacionConfiguracion),
    ]).subscribe(([
      listasfuentescapacidadpago,
      listasDecisionesCapacidadPagoOcupaciones,
      ocupacionConfigCapacidadPago]) => {

      this.listafuentescapacidadPago = listasfuentescapacidadpago.filter(x => x.indicadorHabilitado === true);
       listasfuentescapacidadpago.map(x =>{
        if (x.indicadorHabilitado === true){
          this.selectListaFuentescapacidadPago.push({label: x.nombre, value: x.idLista});
        }
      });

      this.listasDecisionesCapacidadPagoOcupaciones = listasDecisionesCapacidadPagoOcupaciones.filter(x => x.indicadorHabilitado === true);
      this.listasDecisionesCapacidadPagoOcupaciones.sort((a,b) =>{
        if (a.codigo === 'FIJUNO') return 1;
        if (b.codigo === 'FIJUNO') return -1;
        return 0;
      });

      this.ocupacionConfiguracionCapacidadPago = ocupacionConfigCapacidadPago.filter(ocupacionConfig =>
        this.listafuentescapacidadPago.some(fuente => fuente.idLista === ocupacionConfig.idFuenteCapacidadPago)
      );
      this.listafuentescapacidadPago.map(fuente => {
        const data = new TiposOcupacionesCapacidadPagos();
        if (fuente.indicadorHabilitado &&
          !this.ocupacionConfiguracionCapacidadPago.find(x => x.idFuenteCapacidadPago === fuente.idLista)) {
          data.idFuenteCapacidadPago = fuente.idLista;
          data.fuenteCapacidadPago = fuente.nombre;
          data.idTipoOcupacionConfiguracion = this.idTipoOcupacionConfiguracion;
            this.ocupacionConfiguracionCapacidadPago.push(data);
        }
      });

      this.ocupacionConfiguracionCapacidadPago.sort((a,b) =>
        a.fuenteCapacidadPago.localeCompare(b.fuenteCapacidadPago));

      this.cargarFormulario();
      this.carTabla = false;
      this.cargando = false;

    },error => {
      this.carTabla = false;
      this.cargando = false;
      console.log(error);
    });
  }

  cargarListasDescuentosSalarios(){
    this.carTablaDescuentos = true;
    forkJoin([
      this.ocupacionesConfiguracionesCapacidadPagosService.tiposOcupacionesConfiguracionesDescuentosSalariosAll(this.idTipoOcupacionConfiguracion),
      this.ocupacionesConfiguracionesCapacidadPagosService.tiposOcupacionesConfiguracionesDescuentosSalariosEnable(this.idTipoOcupacionConfiguracion),
    ]).subscribe(([descuentosSalariosAll, descuentosSalariosEnabled]) =>{
      this.configuracionesDescuentosSalarios = descuentosSalariosEnabled;
      this.configuracionesDescuentosSalarios.sort((a, b) => a.desde - b.desde);
      this.carTablaDescuentos = false;
      this.iniciarDescuentoSalarios();
    },error => {
      console.log(error);
      this.carTablaDescuentos = false;
      this.cargando = false;
    })
  }
  async actualizarRegistro(row : TiposOcupacionesCapacidadPagos  ){
    try {
      await firstValueFrom(this.ocupacionesConfiguracionesCapacidadPagosService.guardarOcupacionCofiguracionCapacidadPago(row));
    }catch (error) {
      console.log(error);
      this.navServicio.setMesage( 0,
        {
          severity: 'error',
          summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
          detail: this.navServicio.buscarMensaje( 'MSG_ERRORSERVICIO' )
        } );
    }
  }
  indicadorDecision(index: number, event: any) {
    const decisionCapacidadPagoArray = this.formulario.get('decisionCapacidadPago') as FormArray;
    if (event.checked){
      decisionCapacidadPagoArray.controls.forEach((ctrl, i) => {
        ctrl.setValue(i === index);
      });
    }else {
      decisionCapacidadPagoArray.controls.forEach((ctrl, i) => {
        ctrl.setValue(null);
      });
      this.f.idFuenteCapacidadPago.setValue(null)
    }
    this.guardarSeleccionado()
  }

  async guardarSeleccionado() {
    const controles = this.formulario.get('decisionCapacidadPago') as FormArray;
    const idDecisionCapacidadPago = this.listasDecisionesCapacidadPagoOcupaciones
      .filter((_, index) => controles.at(index).value);
    if (!idDecisionCapacidadPago?.find(x => x.codigo === 'FIJUNO')){
      this.f.idFuenteCapacidadPago.setValue(null);
      this.indicadorFijarUno = false
    }
    if (idDecisionCapacidadPago?.find(x => x.codigo === 'FIJUNO' && !this.f.idFuenteCapacidadPago.value )) {
      this.indicadorFijarUno = true
      this.navServicio.setMesage( 0,
        {
          severity: 'info',
          summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'CAPACIDADPAGOOCUPACION.LBL_INFORMACION' )
        } );
      return;
    }
    else {
      this.tipOcupacion.idFuenteCapacidadPago = idDecisionCapacidadPago[0]?.codigo === 'FIJUNO' ? this.f.idFuenteCapacidadPago.value : null  ;
      this.tipOcupacion.idDecisionCapacidadPago = idDecisionCapacidadPago[0]?.idLista ? idDecisionCapacidadPago[0]?.idLista : null;
    }
      try {
        await  firstValueFrom(this.tipOcupacionConfiguracionServicio.actualizar(this.tipOcupacion));
        this.navServicio.setMesage( 2 );
      }catch (error) {
        console.log(error);
        this.navServicio.setMesage( 0,
          {
            severity: 'error',
            summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
            detail: this.navServicio.buscarMensaje( 'MSG_ERRORSERVICIO' )
          } );
      }
  }

  iniciarDescuentoSalarios(){
    this.fd.desde.setValue(null);
    this.fd.hasta.setValue(null);
    this.fd.porcentajeDescuentoLey.setValue(null);
    this.fd.porcentajeImpuesto.setValue(null);
    const mayorDesde = this.configuracionesDescuentosSalarios.at(-1)?.hasta;
    if (mayorDesde !== undefined) {
      this.fd.desde.setValue(mayorDesde);
      this.mayorDesde = mayorDesde;
    }else {
      this.mayorDesde = undefined;
    }
  }
  editarSeleccionado(data : TiposOcupacionesConfiguracionesDescuentosSalarios) {
    this.fd.desde.setValue(data.desde);
    this.fd.hasta.setValue(data.hasta);
    this.fd.porcentajeDescuentoLey.setValue(data.porcentajeDescuentoLey);
    this.fd.porcentajeImpuesto.setValue(data.porcentajeImpuesto);
    this.mayorDesde = null;
    this.editando = data;
  }

 async guardarDescuentoSalario(){
  this.summit = true
   if (this.formDesSalarios.invalid)return;
   if (this.fd.hasta.value >= 0 && this.fd.hasta.value < this.fd.desde.value)return;
    const nuevoObjDescuentoSalario = new TiposOcupacionesConfiguracionesDescuentosSalarios();
    nuevoObjDescuentoSalario.idTipoOcupacionConfiguracion = this.tipOcupacion.idTipoOcupacionConfiguracion;
    nuevoObjDescuentoSalario.desde = this.fd.desde.value;
    nuevoObjDescuentoSalario.hasta = this.fd.hasta.value;
    nuevoObjDescuentoSalario.porcentajeDescuentoLey = this.fd.porcentajeDescuentoLey.value;
    nuevoObjDescuentoSalario.porcentajeImpuesto = this.fd.porcentajeImpuesto.value;
    nuevoObjDescuentoSalario.idTipoOcupacionConfiguracionDescuentoSalario = this.editando ? this.editando.idTipoOcupacionConfiguracionDescuentoSalario : null;
    nuevoObjDescuentoSalario.auditoriaUsuario = this.autServicio.obtenerUsuario().idUsuario;
    if(!this.editando){
      try {
        await firstValueFrom(this.ocupacionesConfiguracionesCapacidadPagosService.guardarTiposOcupacionesConfiguracionesDescuentosSalarios([nuevoObjDescuentoSalario]));
        this.cargarListasDescuentosSalarios();
        this.summit = false;
        this.editando = null;
        this.navServicio.setMesage( 2 );

      }catch (error) {
        console.log(error);
        this.navServicio.setMesage( 3 );

      }
    }
    if (this.editando) {
      const array: TiposOcupacionesConfiguracionesDescuentosSalarios[] = [];
      array.push(nuevoObjDescuentoSalario);
      this.configuracionesDescuentosSalarios.find(menor => {
          if (menor.idTipoOcupacionConfiguracionDescuentoSalario !== this.editando.idTipoOcupacionConfiguracionDescuentoSalario &&
            menor.hasta === this.editando.desde) {
            menor.hasta = nuevoObjDescuentoSalario.desde;
            menor.auditoriaUsuario = this.autServicio.obtenerUsuario().idUsuario;
            array.push(menor);
          }
        }
      );
      this.configuracionesDescuentosSalarios.find(mayor => {
          if (mayor.idTipoOcupacionConfiguracionDescuentoSalario !== this.editando.idTipoOcupacionConfiguracionDescuentoSalario &&
            mayor.desde === this.editando.hasta) {
            mayor.desde = nuevoObjDescuentoSalario.hasta;
            mayor.auditoriaUsuario = this.autServicio.obtenerUsuario().idUsuario;
            array.push(mayor);
          }
        }
      );

      try {
        await firstValueFrom(this.ocupacionesConfiguracionesCapacidadPagosService.guardarTiposOcupacionesConfiguracionesDescuentosSalarios(array));
        this.cargarListasDescuentosSalarios();
        this.summit = false;
        this.editando = null;
        this.navServicio.setMesage(2);

      } catch (error) {
        console.log(error);
        this.navServicio.setMesage(3);

      }

    }
  }
  async inhabiltarRegistro(data : TiposOcupacionesConfiguracionesDescuentosSalarios){
    data.indicadorHabilitado = false;
    try {
      const registros: TiposOcupacionesConfiguracionesDescuentosSalarios[] = this.configuracionesDescuentosSalarios;
      // Encontrar índice del registro a eliminar
      const index = registros.findIndex(r => r.idTipoOcupacionConfiguracionDescuentoSalario === data.idTipoOcupacionConfiguracionDescuentoSalario);
      if (index === -1) return registros; // no existe, retorno igual

      // Guardar "hasta" del eliminado
      const eliminado = registros[index];

      // Si hay un siguiente, ajustamos su "desde"
      if (index > 0 && index + 1 < registros.length) {
        registros[index + 1].desde = eliminado.desde;
      }
      //se agrega el registro a inhabilitar
      registros.push(data)
      // Eliminar el registro
      registros.splice(index, 1);

      //console.log('###Nuevo obj###',registros) ;

      await firstValueFrom(this.ocupacionesConfiguracionesCapacidadPagosService.guardarTiposOcupacionesConfiguracionesDescuentosSalarios(registros));
      this.cargarListasDescuentosSalarios();
      this.summit = false;
      this.editando = null;
      this.navServicio.setMesage( 2 );

    }catch (error) {
      console.log(error);
      this.navServicio.setMesage( 3 );

    }
  }
}
